import React, { useEffect, useState } from "react";
import api from "../../api";
import { useNavigate } from "react-router-dom";

export default function MegaScholarshipResultList() {
  const nav = useNavigate();
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/student/mega-scholarship/my-results")
      .then(res => setResults(res.data || []))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div style={pageStyle}>
      <div style={overlayStyle}>
        <div style={cardStyle}>
          <Header />

          <h2>🏆 Mega Scholarship Results</h2>

          {loading && <p>Loading...</p>}
          {!loading && results.length === 0 && <p>No results found.</p>}

          {results.map(r => (
            <div
              key={r.exam_id}
              style={resultCard}
              onClick={() => nav(`/student/result/mega/${r.exam_id}`)}
            >
              <h4>{r.title}</h4>
              <p>Score: {r.score}/{r.total_questions}</p>
            </div>
          ))}

          <button onClick={() => nav("/student/results")}>
            ⬅ Back to Results
          </button>
        </div>
      </div>
    </div>
  );
}

function Header() {
  return (
    <div style={{ textAlign: "center", marginBottom: 20 }}>
      <img src="/logo.png" alt="EduAt10" style={{ width: 120 }} />
    </div>
  );
}

const pageStyle = {
  minHeight: "100vh",
  backgroundImage: "url('/eduat10-bg.png')",
  backgroundSize: "cover",
};
const overlayStyle = {
  minHeight: "100vh",
  backgroundColor: "rgba(0,0,0,0.25)",
  padding: 20,
};
const cardStyle = {
  maxWidth: 1000,
  margin: "auto",
  background: "#fff",
  borderRadius: 16,
  padding: 30,
};
const resultCard = {
  padding: 15,
  marginBottom: 12,
  border: "1px solid #ddd",
  borderRadius: 8,
  cursor: "pointer",
};
